import * as visit from 'unist-util-visit';
export var STANDALONE_LINK_PLUGIN_ID = 'mfStandaloneLink';
export var StandaloneLink = function () {
  return function (tree) {
    var visitor = function (_a) {
      var children = _a.children;
      if (children.length === 1 && children[0].type === 'link') {
        var link = children[0];
        link.type = STANDALONE_LINK_PLUGIN_ID;
      }
    };
    visit(tree, 'paragraph', visitor);
  };
};